function NotificationSlice(set, get) {
  return {
    notification: {
      isInitialized: false,
      allRows: [],
      isUnReadInitialized: false,
      unRead: 0,
      tasks: [],
      pendingTaskCount: 0,
    },
  };
}

export default NotificationSlice;
